(function () {
    'use strict';

    angular
        .module('core.services')
        .service('HttpService', HttpService);

    function HttpService($http, ROUTES) {
        const HttpService = {
            get,
            post,
            put,
            delete: qdelete
        };

        return HttpService;

        function get(url, config) {
            return $http
                .get(`${ROUTES.API}${url}`, config)
                .then(response => {
                    if (response != null && response != undefined)
                        return response.data;

                    return response;
                });
        }

        function post(url, data, config) {
            return $http
                .post(`${ROUTES.API}${url}`, data, config)
                .then(response => {
                    if (response != null && response != undefined)
                        return response.data;

                    return response;
                });
        }

        function put(url, data) {
            return $http
                .put(`${ROUTES.API}${url}`, data)
                .then(response => {
                    if (response != null && response != undefined)
                        return response.data;

                    return response;
                });
        }

        function qdelete(url, config) {
            return $http.delete(`${ROUTES.API}${url}`, config);
        }
    }
})();